import React from 'react';

import type { ThemeState } from '@atlaskit/tokens/theme-config';

import { GithubThemedIcon } from '../../../constants/3p-product-configs/github/themed-icon';
import GithubBannerDarkGif from '../assets/github_dark.gif';
import GithubBannerLightGif from '../assets/github_light.gif';
import type { OAuthSocialProofMessageContent } from '../types';

import { messages } from './messages';

export interface GetGithubOAuthSocialProofMessageContentParams {
	colorMode?: ThemeState['colorMode'];
}

/**
 * Returns the GitHub-specific config that should be spread onto `<OAuthSocialProofMessage />`.
 */
export const getGithubOAuthSocialProofMessageContent = ({
	colorMode,
}: GetGithubOAuthSocialProofMessageContentParams): OAuthSocialProofMessageContent => {
	return {
		productIcon: <GithubThemedIcon />,
		description: messages.description,
		successFlagTitle: messages.successFlagTitle,
		successFlagDescription: messages.successFlagDescription,
		// Use the dark GIF only when the theme is explicitly dark, default to the light GIF otherwise
		imageSrc: colorMode === 'dark' ? GithubBannerDarkGif : GithubBannerLightGif,
	};
};
